import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { observable } from 'mobx';

import { Table, Column, Button } from '@smartplatform/ui';
import store from '../../store';

@withRouter @observer
export default class List extends React.Component {
	
	@observable records = null;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.records = await store.model.PlenarySession.find({ order: 'id desc' });
	};
	
	create = () => this.props.history.push('/admin/plenarysessions/create');
	
	importFromSazd = () => this.props.history.push('/admin/plenarysessions/sazd');
	
	render() {
		if (!this.records) return '...';
		
		return <div className="plenary-sessions">
			<p>Пленарные заседания</p>
			<p>
				<Button className="btn-primary" onClick={this.importFromSazd}>Импорт из САЗД в EPZ</Button>
				<Button className="btn-primary" onClick={this.create}>Создать</Button>
			</p>
			<Table records={this.records} rootPath="/admin">
				<Column width={60} property="id" label="id" />
				<Column property="name" label="Наименование" />
				<Column width={120} property="publish" label="Опубликовано" />
			</Table>
		</div>;
	}
	
}
